import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../modules/administration/models/user';
import { SessionService } from '../../modules/administration/services/session.service';
import { AuthSessionServiceDelegate } from '../../authentication/services/delegate.auth.session.service';


@Component({
  selector: 'app-head',
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.scss']
})
export class HeadComponent implements OnInit {

  public user: User;
  public date: string;

  constructor(private session: SessionService, private router: Router, private authSessionService: AuthSessionServiceDelegate) {
  }

  public ngOnInit() {
    this.session._userBs.subscribe(data => {
      this.user = data;
    });

    this.session._dateBs.subscribe(data => {
      this.date = data;
    });
  }

  OpenMenu() {
    if (document.getElementById('sidenav-mobile') != null) {
      document.getElementById('sidenav-mobile').style.width = '320px';
    }
    if (document.getElementById('opacity') != null) {
      document.getElementById('opacity').style.display = 'block';
    }
  }
}
